export enum AssistiveDevice {
  NONE = 0,
  POLES = 1,
  CANE = 2,
  CRUTCH_SINGLE = 3,
  CRUTCH_DOUBLE = 4,
  WALKER = 5,
  ROLLATOR = 6,
  Wheelchair = 7,
}

export enum AssistiveDeviceLabels {
  'none' = 0,
  'walking-poles' = 1,
  'cane' = 2,
  'crutch' = 3,
  'crutches' = 4,
  'walker' = 5,
  'rollator' = 6,
  'wheel-chair' = 7,
}

export enum LevelOfAssistance {
  'Independent' = 1,
  'Modified Independent' = 2,
  'Standby Assistance' = 3,
  'Minimal Assistance' = 4,
  'Moderate Assistance' = 5,
  'Maximum Assistance' = 6,
  'Total Assistance' = 7,
  'Unable To Perform At This Time' = 8,
}
